import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EngagementType } from '../../../models/engagement-type.model';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { UploadHistoryComponent } from '../upload-history/upload-history.component';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-private-workshop-access-lists',
  templateUrl: './private-workshop-access-lists.component.html',
  styleUrls: ['./private-workshop-access-lists.component.scss'],
  standalone: true,
  imports: [UploadHistoryComponent, CommonSharedModule]
})
export class PrivateWorkshopAccessComponent implements OnInit {
  privateEngagementTypeList!: EngagementType[];
  privateWorkshopForm!: FormGroup;
  selectedTab!: number;
  selectedWorkshopType!: number;
  loading = true;
  @ViewChild('uploadHistory', { static: false })
  uploadHistory!: UploadHistoryComponent;

  programtypes = [
    { programName: 'MCAP', programTypeID: 1 },
    { programName: 'CSI', programTypeID: 2 },
    { programName: 'Operator', programTypeID: 3 },
    { programName: 'Advisor Incentive', programTypeID: 5 }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private osmEdit: OsmosisEditService
  ) {}

  ngOnInit(): void {
    this.selectedTab = 0;
    this.loading = false;
    this.onFromGroup();
  }

  onFromGroup(): void {
    this.privateWorkshopForm = this.formBuilder.group({
      partnerWorkshopType: ['']
    });
  }

  onProgramTypeSelect(event: { value: { programTypeID: number } }): void {
    this.loading = true;
    this.osmEdit
      .getPrivateEngagementTypeDropDown(event.value.programTypeID)
      .subscribe(engagements => {
        this.loading = false;
        this.privateEngagementTypeList = engagements;
      });
  }

  onWorkshopTypeSelect(): void {
    this.uploadHistory.engagementType =
      this.privateWorkshopForm.controls[
        'partnerWorkshopType'
      ].value.engagementType;
    this.uploadHistory.loadWorkshopUploadHistory(
      this.privateWorkshopForm.controls['partnerWorkshopType'].value
        .engagementTypeId
    );
    this.uploadHistory.isHybridWithCustomerList =
      this.privateEngagementTypeList.find(
        x =>
          x.engagementTypeId ==
          this.privateWorkshopForm.controls['partnerWorkshopType'].value
            .engagementTypeId
      )!.isHybridWithCustomerList!;

    this.uploadHistory.isHybridWithPartnerList =
      this.privateEngagementTypeList.find(
        x =>
          x.engagementTypeId ==
          this.privateWorkshopForm.controls['partnerWorkshopType'].value
            .engagementTypeId
      )!.isHybridWithPartnerList!;
  }
}
